import React from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import TabSwitcher from "../shared/TabSwitcher";

const AccountLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabOptions = [
    {
      title: "درآمد",
      value: "incomes",
      path: "/account/incomes",
      active: true,
    },
    {
      title: "صورتحساب",
      value: "statements",
      path: "/account/statements",
      active: true,
    },
    {
      title: "پرداخت",
      value: "withdraws",
      path: "/account/withdraws",
      active: true,
    },
  ];

  // Determine active tab based on current location
  const activeTab = tabOptions.find((tab) =>
    location.pathname.includes(tab.value),
  )?.value;

  const handleSwitch = (value) => {
    const selectedTab = tabOptions.find((tab) => tab.value === value);
    if (selectedTab) {
      navigate(selectedTab.path);
    }
  };

  return (
    <section className="h-full flex flex-col gap-3 w-full">
      <figure className="figure-wrapper ">
        <TabSwitcher
          activeTab={activeTab}
          handleSwitch={handleSwitch}
          options={tabOptions.map(({ title, value, active }) => ({
            title,
            value,
            active,
          }))}
        />
      </figure>
      <div className="h-full pb-4 overflow-y-scroll no-scrollbar">
        <Outlet />
      </div>
    </section>
  );
};

export default AccountLayout;
